import React from 'react';
import Localize from 'react-intl-universal';
import { useNavigate } from 'react-router-dom';

import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';

const StyledButton = styled(Button)(({ theme }) => ({
  minWidth: '10rem !important',
  textTransform: 'none !important',
  fontWeight: '700 !important',
  fontSize: '14px !important',
  height: '3rem',
  alignSelf: 'center',
  [theme.breakpoints.up('sm')]: {
    height: 'auto'
  }
}));

const CancelButton = ({ goBack = '/', redirectFrom, redirectPath, sx = {} }) => {
  let navigate = useNavigate();

  const redirectToDetails = () => {
    navigate(goBack, {
      state: {
        from: Localize.get(redirectFrom),
        path: redirectPath
      }
    });
  };

  return (
    <StyledButton sx={sx} variant='outlined' onClick={redirectToDetails}>
      {Localize.get('Booking.cancelBooking')}
    </StyledButton>
  );
};

export default CancelButton;
